export default "__VITE_ASSET__D9J_p6WU__"